var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-group input-group-sm" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.fileNameWithoutExtension,
          expression: "fileNameWithoutExtension"
        },
        { name: "focus", rawName: "v-focus" }
      ],
      staticClass: "form-control py-0 px-1",
      domProps: { value: _vm.fileNameWithoutExtension },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.fileNameWithoutExtension = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text py-0 px-1" }, [
        _vm._v(_vm._s(_vm.extension))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b6fe34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b6fe34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/FileNameEditor.vue
// module id = 543
// module chunks = 0